module.exports = __webpack_public_path__ + "img/03.76d33acb.jpg";